import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

import { EMPTY, TimeoutError, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('DEFAULT_TIMEOUT', {
  factory: () => 5 * 60 * 1000 // 5 minutes
});

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const defaultTimeout = inject(DEFAULT_TIMEOUT);
  const timeoutValue = req.headers.get('X-Timeout-Ms') ?? defaultTimeout;
  const timeoutValueNumeric = Number(timeoutValue);
  return next(req).pipe(
    timeout(timeoutValueNumeric),
    catchError((err: unknown) => {
      if (err instanceof TimeoutError) {
        console.error('Timeout has occurred');
        return EMPTY;
      }
      return throwError(() => err);
    })
  );
};
